/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    currentMedic?: unknown;
  };
}

import { service } from "@ember/service";
import Component from "@glimmer/component";
import type ParogService from "parog-web/services/parog";
import type SemeiaSessionService from "parog-web/services/session";
import { isProduction } from "parog-web/utils/runtime-environment";

import styles from "./component.module.css";

export default class DropdownHeaderComponent extends Component<Signature> {
  styles = styles;

  @service declare session: SemeiaSessionService;
  @service declare parog: ParogService;

  get isProduction() {
    return isProduction();
  }

  get toucanEnabled(): boolean {
    return Boolean(
      this.session.medic?.healthCentres?.some(
        healthCentre => healthCentre.toucanEnabled
      )
    );
  }

  toggleWiser = () => {
    this.parog.wiser = !this.parog.wiser;
  };
}
